import {IconProps} from "../icon/Icon";
import {Box} from "@mui/material";
import React from "react";

export interface NavItemIconProps {
    icon: React.ComponentType<IconProps>;
}


export default function NavItemIcon(props: Readonly<NavItemIconProps>) {
    const {icon: Icon} = props;
    return (
        <Box color={"white"} alignContent={"center"}>
            <Icon size="s"/>
        </Box>
    );
}
